import { render, staticRenderFns } from "./RiskTaskModal.vue?vue&type=template&id=5dddef59&"
import script from "./RiskTaskModal.vue?vue&type=script&lang=js&"
export * from "./RiskTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports